<template>
    <el-form ref="form" label-width="160px" :rules="rules" :model="dioForm">
        <el-form-item :label="$t('probeunit.unitMeasurement')" prop="name">
            <el-input
                v-model.trim="dioForm.name"
                style="width: 250px"
                maxlength="20"
            ></el-input>
        </el-form-item>
        <el-form-item :label="$t('probeunit.unitMark')" prop="title">
            <el-input
                v-model.trim="dioForm.title"
                style="width: 250px"
                maxlength="50"
            ></el-input>
        </el-form-item>
        <el-form-item :label="$t('probeunit.unitNumber')" prop="code">
            <el-input
                :disabled="dioForm.id"
                v-model.trim="dioForm.code"
                style="width: 250px"
                maxlength="50"
            ></el-input>
        </el-form-item>
        <el-form-item :label="$t('probeunit.describe')" prop="desc">
            <el-input
                v-model.trim="dioForm.desc"
                style="width: 250px"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 10 }"
                show-word-limit
                maxlength="250"
            ></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    computed: {
        rules() {
            return {
                name: [{ required: true, message: this.$t('probeunit.uOMCannotBeBlank'), trigger: 'blur' }],
                title: [{ required: true, message: this.$t('probeunit.unitCannotBeBlank'), trigger: 'blur' }],
                code: [{ required: true, message: this.$t('probeunit.unitNumberCannotBeBlank'), trigger: 'blur' },
                {
                    validator: this.$fromRules.FormValidate.Form().Codes,
                    trigger: 'blur',
                }
                ],
            }
        }
    },
    data() {
        return {
            dioForm: {
                name: null,
                title: null,
                code: null,
                desc: null
            },
        }
    },
    methods: {
        // 子组件的校验方法
        async justify() {
            try {
                return await this.$refs['form'].validate()
            }
            catch (error) {
                return false
            }
        },
        clearValidate() {
            if (this.$refs.form) {
                this.$refs.form.resetFields();
            }
        },
    }
}
</script>

<style>
</style>